import Schema, { array } from 'AppReact/schema';

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  showPdf: Schema('boolean', 'primitive', { defaultValue: false }),
  includeImages: Schema('boolean', 'primitive', { defaultValue: true }),
  includeComments: Schema('boolean', 'primitive', { defaultValue: true }),
  includeCost: Schema('boolean', 'primitive', { defaultValue: true }),
  hideCost: Schema('boolean', 'primitive', { defaultValue: true }),
  hideImages: Schema('boolean', 'primitive', { defaultValue: false }),
  disabled: Schema('boolean', 'primitive', { defaultValue: false }),
}